export default __webpack_public_path__ + "static/white-nr-44c1bcd606390791168bf061bbfe3c95.png";